<template lang="pug" src="./html/InstagramCodesQRARCodes.pug"></template>

<script>

  import Vue from 'vue'
  import ArticleItemBase from './ArticleItemBase'

  const InstagramCodesQRARCodesBody = () => import(/* webpackChunkName: "instagram-codes-qr-ar-codes" */ './InstagramCodesQRARCodes-Body')

  Vue.component('InstagramCodesQRARCodesBody', InstagramCodesQRARCodesBody)

  export default {
    extends: ArticleItemBase,
    mounted () {
      this.setBody('InstagramCodesQRARCodesBody')
    }
  }
</script>

<style lang="sass" src="./style/ArticleItem.sass"></style>

<style scoped>
    .article-item {
        background-color: #D43486;
        color: #f9c9da;
    }
    .article-item h1, .article-item h2 {
        color: #FFFFFF;
    }
    .article-item .bg {
        background-color: #9a1599;
        padding: 4px 10px 6px 6px;
        margin-left: -6px;
    }
</style>

<style>
    #app.scan-insta-qr-ar #top-header {
        background-color: #9a1599;
    }
    #app.scan-insta-qr-ar #load-anim {
        stroke: #9a1599;
    }
</style>
